import React from "react";
import { TipStatus } from "model/Tip";
import { Color } from "config/colors";
import { useTranslation } from "react-i18next";
import { Logo } from "components/nav/logo/logo.styled";
import { Text } from "components/Typography/text.styled";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import SimflexityPayLogo from "images/logo/svg/simflexityPay-logo.svg";
import { FontFamily } from "config/font";
import { ManualPaidContent, ManualPaidContainer } from "../tips.styled";
import UndoIcon from "@material-ui/icons/Undo";

interface TipStatusProps {
  status: TipStatus;
  onUndo?: () => void;
  undoLoading?: boolean;
};

export const TipStatusIndicator: React.FC<TipStatusProps> = (props) => {
  const { t } = useTranslation();

  switch (props.status) {
    case TipStatus.Created:
      return (
        <Text fontFamily={FontFamily.MontserratSemiBold}>
          {t("CompanyTip.Created")}
        </Text>
      );
    case TipStatus.Saved:
      return (
        <Text fontFamily={FontFamily.MontserratSemiBold}>
          {t("CompanyTip.SavedTip")}
        </Text>
      );
    case TipStatus.Done:
      return (
        <Text fontFamily={FontFamily.MontserratSemiBold}>
          {t("CompanyTip.ReadyToPayout")}
        </Text>
      );
    case TipStatus.Closed:
      return (
        <Logo
          src={SimflexityPayLogo}
          style={{
            height: "18px",
            width: "auto",
            marginLeft: "10px",
          }}
          alt="SimflexityPay logo"
        />
      );
    case TipStatus.ClosedManually:
      return (
        <ManualPaidContainer>
          <ManualPaidContent>
            <CheckCircleIcon
              fontSize="small"
              style={{ color: Color.ModernGreen }}
            />

            <Text
              color={Color.ModernGreen}
              fontFamily={FontFamily.MontserratSemiBold}
              style={{
                margin: 0,
                whiteSpace: "nowrap",
                lineHeight: 1.1,
              }}
              title={t("CompanyTip.PaidManually")}
            >
              {t("CompanyTip.ManuallyPaid")}
            </Text>
            {props.onUndo && (
              <UndoIcon
                fontSize="small"
                onClick={props.onUndo}
                style={{
                  cursor: "pointer",
                  marginLeft: "6px",
                  color: Color.MidnightBlue,
                }}
              />
            )}
          </ManualPaidContent>
        </ManualPaidContainer>
      );

    default:
      return <Text>""</Text>;
  }
};
